import React from 'react';

export interface PlaceholderTabConfig {
  filterFields?: string[];
  summaryCards?: { label: string; value: string }[];
  columns: string[];
  emptyMessage?: string;
  showCheckbox?: boolean;
}

interface PlaceholderTabPanelProps {
  config: PlaceholderTabConfig;
}

export const PlaceholderTabPanel: React.FC<PlaceholderTabPanelProps> = ({ config }) => {
  const { filterFields = [], summaryCards = [], columns, emptyMessage, showCheckbox } = config;

  return (
    <div className="space-y-6">
      {filterFields.length > 0 && (
        <div className="bg-white border border-gray-200 rounded-lg p-4 space-y-3">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
            {filterFields.map((field) => (
              <div key={field}>
                <label className="block text-xs text-gray-500 mb-1">{field}</label>
                <div className="h-10 rounded-lg border border-gray-200 bg-gray-50 px-3 flex items-center text-sm text-gray-400">
                  Chọn {field.toLowerCase()}
                </div>
              </div>
            ))}
          </div>
          {filterFields.length > 4 && (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
              {filterFields.slice(4).map((field) => (
                <div key={field}>
                  <label className="block text-xs text-gray-500 mb-1">{field}</label>
                  <div className="h-10 rounded-lg border border-gray-200 bg-gray-50 px-3 flex items-center text-sm text-gray-400">
                    {field.includes('Tìm') ? 'Nhập từ khóa...' : `Chọn ${field.toLowerCase()}`}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {summaryCards.length > 0 && (
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          {summaryCards.map((card) => (
            <div
              key={card.label}
              className="bg-white border border-gray-200 rounded-lg p-5 text-center"
            >
              <div className="text-2xl font-bold text-gray-900">{card.value}</div>
              <div className="text-sm text-gray-500 mt-1">{card.label}</div>
            </div>
          ))}
        </div>
      )}

      <div className="bg-white border border-gray-200 rounded-lg overflow-hidden">
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                {showCheckbox && (
                  <th className="px-4 py-3 w-10">
                    <input type="checkbox" disabled className="rounded border-gray-300" />
                  </th>
                )}
                {columns.map((col) => (
                  <th
                    key={col}
                    className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider whitespace-nowrap"
                  >
                    {col}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              <tr>
                <td
                  colSpan={columns.length + (showCheckbox ? 1 : 0)}
                  className="px-4 py-16 text-center"
                >
                  <div className="flex flex-col items-center gap-3 text-gray-400">
                    <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={1.5}
                        d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                      />
                    </svg>
                    <p className="text-sm font-medium text-gray-500">
                      {emptyMessage ?? 'Chức năng đang được phát triển'}
                    </p>
                    <p className="text-xs text-gray-400">
                      Giao diện đã sẵn sàng — dữ liệu sẽ được kết nối trong các bước tiếp theo
                    </p>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between gap-3 px-4 py-3 border-t border-gray-200 bg-gray-50 text-sm text-gray-500">
          <span>Tổng 0</span>
          <div className="flex items-center gap-3">
            <select disabled className="rounded border border-gray-200 bg-white px-2 py-1 text-sm">
              <option>20/trang</option>
            </select>
            <div className="flex items-center gap-1">
              <button type="button" disabled className="p-1 rounded hover:bg-gray-200 disabled:opacity-40">
                ‹
              </button>
              <span className="px-2 py-1 bg-cyan-600 text-white rounded text-xs">1</span>
              <button type="button" disabled className="p-1 rounded hover:bg-gray-200 disabled:opacity-40">
                ›
              </button>
            </div>
            <span className="flex items-center gap-1">
              Nhảy tới
              <input
                type="text"
                disabled
                defaultValue="1"
                className="w-12 rounded border border-gray-200 px-2 py-1 text-center text-sm"
              />
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
